export default [
  {
    category: 'Guests',
    questions: [
      'Who is your dream dinner guest?',
      'Do you enjoy hosting guests? Why or why not?'
    ]
  },
  {
    category: 'Fame',
    questions: [
      'Would you like to be famous? In what way?',
      'What famous person would you like to be friends with and why?'
    ]
  },
  {
    category: 'Nicknames',
    questions: [
      'Have you ever had a nickname? What was it?',
      'Do you have a nickname you wish people would call you more?'
    ]
  },
  {
    category: 'Music',
    questions: [
      'What is your go-to Karaoke song?',
      'What was your first album?',
      'Who is your favorite band and when did you start listening to them?',
      'What was your favorite concert you\'ve ever been to?',
      'What are your top radio stations?',
      'What is your favorite genre of music?',
      'What is a song that meant a lot to you growing up?',
      'What is a song that really takes you back?',
      'What band do you think is overrated?',
      'What is a band or artist you\'ve discovered recently that you\'ve been enjoying?'
    ]
  },
  {
    category: 'Chores',
    questions: [
      'What is your least favorite chore?',
      'What\'s a chore you enjoy doing?',
      'If you could hire someone to help you, would it be with cleaning, cooking, or yard work?'
    ]
  },
  {
    category: 'Animals',
    questions: [
      'What is your spirit animal?',
      'How do you feel about zoos?',
      'If you were an animal, what kind of animal would you be?',
      'What pets do you have?'
    ]
  },
  {
    category: 'Growing Old',
    questions: [
      'If you were able to live to the age of 90 and retain either the mind or body of a 30-year-old for the last 60 years of your life, which would you choose?',
      'What do you think the last 10 years of your life will look like?'
    ]
  },
  {
    category: 'Jacob',
    questions: [
      'Name three things you and Jacob have in common.',
      'Name three positive characteristics about Jacob.'
    ]
  },
  {
    category: 'Books',
    questions: [
      'What is a really good book you\'ve read recently?',
      'What book did you really like growing up?',
      'What is a book you really enjoy?',
      'What was the last book you read? What did you think?',
      'What kind of books do you enjoy the most?',
      'Who is your favorite author?'
    ]
  },
  {
    category: 'Movies',
    questions: [
      'What is a really good movie you\'ve seen recently?',
      'What movie did you really like growing up?',
      'What was the last movie you went to? What did you think?',
      'What is a movie you could never get tired of seeing?',
      'What kind of movies do you enjoy the most?',
      'What movie are you looking forward to?',
      'Who would you want to play you in a movie of your life?'
    ]
  },
  {
    category: 'Games',
    questions: [
      'What is your favorite game?',
      'What game did you really like growing up?',
      'What was the last game you played? What did you think?',
      'What kind of games do you enjoy the most?'
    ]
  },
  {
    category: 'Food',
    questions: [
      'What is a really restaurant you\'ve been to recently?',
      'What kind of food did you really enjoy growing up?',
      'What is your favorite kind of food?',
      'What is your favorite restaurant?',
      'What do you enjoy cooking?',
      'What\'s your favorite fast food chain?',
      'What\'s the most unusual thing you\'ve ever eaten?'
    ]
  },
  {
    category: 'Growing Up',
    questions: [
      'If you could change anything about the way you were raised, what would it be?',
      'Do you feel your childhood was happier than most other people\'s?',
      'What is something you miss from your childhood, if anything?',
      'What did you want to be when you grew up when you were a kid?',
      'What was your favorite place to go as a child and why?'
    ]
  },
  {
    category: 'Gaining Knowledge',
    questions: [
      'If a crystal ball could tell you the truth about yourself, your life, the future or anything else, what would you want to know?',
      'What is one thing you learned this week?',
      'If you could spend an entire week learning something new, what would it be and why?'
    ]
  },
  {
    category: 'Accomplishments',
    questions: [
      'What is the greatest accomplishment of your life?',
      'What has been your greatest accomplishment this year?',
      'What goal would you like to accomplish in the next 5 years?'
    ]
  },
  {
    category: 'Friendship',
    questions: [
      'What do you value most in a friendship?',
      'What does friendship mean to you?',
      'Describe a true friend in your life, past or present.'
    ]
  },
  {
    category: 'Memories',
    questions: [
      'What is your most treasured memory?',
      'What is your most terrible memory?',
      'Share an embarrassing moment in your life.',
      'What is your favorite memory with Jacob?',
      'What is something you miss?'
    ]
  },
  {
    category: 'Death',
    questions: [
      'If you knew that in one year you would die suddenly, would you change anything about the way you are now living? Why?',
      'Do you have a secret hunch about how you will die?',
      'If you were to die this evening with no opportunity to communicate with anyone, what would you most regret not having told someone? Why haven\'t you told them yet?',
      'Of all the people in your family, whose death would you find most disturbing? Why?'
    ]
  },
  {
    category: 'Love and Affection',
    questions: [
      'When was the last time you felt loved?',
      'What is your love language?',
      'Do you love yourself? Why or why not?'
    ]
  },
  {
    category: 'Super Heroes',
    questions: [
      'Who is your favorite super hero and why?',
      'If you were a super-hero, what powers would you have?',
      'What super hero movie are you looking forward to?'
    ]
  },
  {
    category: 'Dress/Clothing',
    questions: [
      'How many pairs of shoes do you own?',
      'How would you describe your style of dress?',
      'What style of dress do you wish you could pull off?',
      'How often do you buy clothes?',
      'Is there anything you wished would come back into fashion?'
    ]
  },
  {
    category: 'Crying',
    questions: [
      'When did you last cry in front of another person?',
      'What has made you cry or feel upset recently?',
      'Describe a scene from a movie or TV show that made you cry?'
    ]
  },
  {
    category: 'Humor',
    questions: [
      'What, if anything, is too serious to be joked about?',
      'Describe your style of humor.'
    ]
  },
  {
    category: 'Money',
    questions: [
      'If someone gave you $100, what would you spend it on?',
      'If someone gave you enough money to start a business, no strings attached, what kind of business would you want to start?',
      'What would you do with a million dollars?',
      'If you had enough money to retire right now, would you quit your job? Why or why not?'
    ]
  },
  {
    category: 'Secrets',
    questions: [
      'Is it ever okay to keep secrets from your partner? Why or why not?',
      'When are you most likely to open up to someone and share secrets?'
    ]
  },
  {
    category: 'Infidelity',
    questions: [
      'What is your definition of cheating?',
      'Have you ever cheated on someone? What happened?',
      'Have you ever been cheated on? What happened?'
    ]
  },
  {
    category: 'Dating and Relationships',
    questions: [
      'What is your favorite date you\'ve ever had? Why?',
      'What would the perfect first date look like?',
      'What is the most important thing in a relationship to you?',
      'What is your biggest fear in a relationship?'
    ]
  },
  {
    category: 'Your Ex',
    questions: [
      'Describe the details of your last breakup.',
      'How do you feel about your most recent ex?',
      'Are you still friends with your most recent ex? Why or why not?'
    ]
  },
  {
    category: 'Feeling Alive',
    questions: [
      'What is one thing or activity that makes you feel alive?',
      'Describe a time in your life when you truly felt alive?'
    ]
  },
  {
    category: 'Religion',
    questions: [
      'Do you believe in God? Why or why not?',
      'Describe your experience with religion, including any religious upbringing.'
    ]
  },
  {
    category: 'Pet Peeves',
    questions: [
      'List three pet peeves.',
      'What is your biggest pet peeve when driving?',
      'What is your biggest pet peeve at work?'
    ]
  },
  {
    category: 'Gifts',
    questions: [
      'What is the best gift you have been given?',
      'What is the worst gift you have received?'
    ]
  },
  {
    category: 'Free Time',
    questions: [
      'What do wish you could spend more time on?',
      'If you had an entire day to yourself, how would you spend it?',
      'What is your favorite way to spend your free time?',
      'If you could take a year-long paid sabbatical, what would you do?'
    ]
  },
  {
    category: 'Feeling Noticed',
    questions: [
      'What is one thing you wish people would compliment you more on?',
      'What makes you feel appreciated?',
      'What ways could you better show your appreciation to others?'
    ]
  },
  {
    category: 'The Future',
    questions: [
      'What are you most looking forward to right now?',
      'Five years from now, how do you envision your life?',
      'When you think about you future, what do you imagine?'
    ]
  },
  {
    category: 'Adventure',
    questions: [
      'What adventure would you like to do in the next few months?',
      'What spontaneous things have you done this month?',
      'What\'s one of the most adventurous things you have ever done?'
    ]
  },
  {
    category: 'Bucket List',
    questions: [
      'Is there something that you\'ve dreamed of doing for a long time? Why haven\'t you done it?',
      'What do you hope will be the next thing you cross off your bucket list?'
    ]
  },
  {
    category: 'Appearance',
    questions: [
      'What do you think is your sexiest feature?',
      'What do you like most about your appearance?',
      'When it comes to appearance, what are you attracted to?'
    ]
  },
  {
    category: 'Past Failure',
    questions: [
      'What is one thing that didn\'t work out in the past but you\'re so glad it didn\'t?',
      'What is one thing that didn\'t work out in the past that you regret?'
    ]
  },
  {
    category: 'Work',
    questions: [
      'If money didn\'t matter, what occupation would you choose?',
      'What are your career ambitions?',
      'How do you feel about your job? Are you trying to change the way you feel about it?',
      'What is your favorite thing about your current job or career?',
      'What is your biggest complaint about your job?',
      'How long does it take you to get ready for work in the morning?',
      'What was your first job?'
    ]
  },
  {
    category: 'Dreams',
    questions: [
      'Describe any recurring dreams that you have or have had.',
      'What is one the most vivid dreams you remember ever having?'
    ]
  },
  {
    category: 'Change',
    questions: [
      'Over the last five years, how do you think you have changed?',
      'What is something you want to change about yourself and why?',
      'If you could change one thing about your current life, what would it be?',
      'If you could wake up tomorrow having gained any one quality or ability, what would it be?'
    ]
  },
  {
    category: 'Drinking',
    questions: [
      'What are you like when you\'re drunk? If you\'ve never been drunk, what do you think you would be like?',
      'What is your current relationship with drinking?',
      'What is the drunkest you\'ve ever been?'
    ]
  },
  {
    category: 'Vacation',
    questions: [
      'What was your favorite family vacation?',
      'What was your last vacation?',
      'Where do you hope to go on vacation next?',
      'What is your favorite vacation spot?',
      'Where do you think Jacob would love vacationing and why?'
    ]
  },
  {
    category: 'Anger',
    questions: [
      'What really makes you angry?',
      'What has recently made you angry?',
      'How do you handle anger?'
    ]
  },
  {
    category: 'Motivation',
    questions: [
      'What motivates you to work hard?',
      'Who do you find motivational?',
      'What song do you find motivational?'
    ]
  },
  {
    category: 'Holidays',
    questions: [
      'What is your favorite holiday? Why?',
      'Is there a holiday you don\'t like? Why?',
      'What is your favorite holiday tradition?'
    ]
  },
  {
    category: 'Theme Parks',
    questions: [
      'Do you love or hate roller coasters?',
      'What\'s your favorite ride?',
      'How often did you go to theme parks growing up versus now?'
    ]
  },
  {
    category: 'School',
    questions: [
      'What was your favorite subject in school?',
      'What was your worst subject in school?',
      'Who was your favorite teacher?',
      'How would you describe yourself in high school?'
    ]
  },
  {
    category: 'Birthdays',
    questions: [
      'Have you ever had a surprise birtday party? How did it go?',
      'How do you hope to spend your next birthday?',
      'What was a really memorable birthday for you?'
    ]
  },
  {
    category: 'Working Out',
    questions: [
      'What do you do to keep fit?',
      'What is your favorite workout?'
    ]
  },
  {
    category: 'Crushes',
    questions: [
      'Who was your first crush?',
      'Do you currently have a crush on anyone? Who?',
      'Who\'s your celebrity crush?',
      'Who did you have a serious crush on that didn\'t feel the same way?'
    ]
  },
  /*
  {
    category: '',
    questions: [
      '',
      ''
    ]
  },
  {
    category: '',
    questions: [
      '',
      ''
    ]
  },
  {
    category: '',
    questions: [
      '',
      ''
    ]
  },
  {
    category: '',
    questions: [
      '',
      ''
    ]
  },
  {
    category: '',
    questions: [
      '',
      ''
    ]
  }
  */
]